export default __webpack_public_path__ + "static/media/5w-30_Svelt_L.5c85c00f.png";